export const CHILIPIPER_FORM_IDS = [
  '6',
  '31',
  '406',
  '407',
  '420',
  '421',
  '422',
  '423',
  '424',
  '425',
  '426',
  '427',
  '687',
  '689',
  '691',
  '694',
] as const;
